import { createDuck } from '@/utils/'
import { USER_STATUS } from '@/utils/const'
import { isObject } from '@/utils/utils'

import { fetchActivityInfo } from '@/services/api/home'
const { NO_JOIN, NO_AWARD, AWARDED, EXPIRED } = USER_STATUS

//新人活动
export const duck = createDuck({
  name: 'newlyDuck',
  initialState: {
    /** @type {home.ActivityInfo} */
    activityInfo: {},
    /** @type {home.UserInfo} */
    userInfo: {
      state: USER_STATUS.INELIGIBLE,
      items: [],
      to: 0,
    },
    activityStatus: 0,
    hasGift: true,
    showAct: false,
  },
  actions: {
    changeUserState(val) {
      return async (dispatch, getState) => {
        const {
          homeDuck: { userInfo },
        } = getState()
        dispatch(
          duck.change({
            userInfo: { ...userInfo, state: val },
          }),
        )
      }
    },
    changeActShow(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            showAct: val,
          }),
        )
      }
    },
    fetActInfo() {
      return async dispatch => {
        const { data } = await fetchActivityInfo()
        if (isObject(data)) {
          const { activityInfo, userInfo, hasGift } = data
          const { nowTime, to } = activityInfo || {}
          const { state } = userInfo || {}
          const _now = new Date().getTime()

          dispatch(
            duck.change({
              activityStatus: 1,
              activityInfo: { ...activityInfo, _diff: nowTime - _now },
              userInfo: { ...userInfo },
              showAct:
                hasGift &&
                nowTime < to &&
                (state === NO_JOIN || state === NO_AWARD || state === AWARDED || state === EXPIRED),
              hasGift,
            }),
          )
        }
      }
    },

    changeItem(data) {
      return async (dispatch, getState) => {
        const {
          homeDuck: { userInfo },
        } = getState()
        dispatch(
          duck.change({
            userInfo: {
              ...userInfo,
              to: data.to,
              items: data.items,
            },
          }),
        )
      }
    },
  },
})
